<script lang="ts" setup>
import { GpStripePayment } from '@gportal/stripe';
import useGlobalConfig from '@panel/composables/useGlobalConfig';
import { onMounted, ref } from 'vue';

const emit = defineEmits<{ (e: 'update:isValid', value: boolean): void }>();

const { stripe: stripeConfig } = useGlobalConfig();
// single stripe instance for all payment elements
const hasInitError = ref(false);
const initError = ref('');

const clientSecret = ref<string>();
const initStripe = async () => {
  if (stripeConfig == null || stripeConfig.publicKey == null || stripeConfig.publicKey.length === 0)
    return;
};
const gpStripePayment = ref<InstanceType<typeof GpStripePayment>>();
const submit = () => {
  if (gpStripePayment.value == null) {
    throw new Error('Stripe payment component not found.');
  }

  return gpStripePayment.value.submit();
};

defineExpose({
  submit,
});

onMounted(() => {
  initStripe();
});
</script>

<template>
  <div>
    <GpStripePayment
      v-if="!hasInitError && clientSecret != null"
      ref="gpStripePayment"
      :client-secret="clientSecret"
      mount-target-id="payment-element"
      @update:is-valid="(isValid) => emit('update:isValid', isValid)"
    />

    <pre v-if="hasInitError">
      {{ initError }}
    </pre>
  </div>
</template>
